

import Vue from 'vue'
import Component from "vue-class-component";
import {namespace} from "vuex-class";
import CreateButton from "@/components/shared/CreateButton.vue";
import ServiceProviderChip from "@/components/shared/chips/ServiceProviderChip.vue";
import {Prop} from "vue-property-decorator";
import {BoListPanel} from "bonomo";
import {IAnyObject} from "bonomo/dist";
import {BetterDataTableHeader} from "@/model/betterVuetifyInterfaces";
import {IService} from "@/model/Service/serviceInterfaces";
import {UrlHelper} from "@/helpers/UrlHelper";
import {ITranslatedField, TranslationHelper} from "@/helpers/TranslationHelper";
import {IServiceProvider} from "@/model/Service/serviceProviderInterfaces";
import BoListFilters from "@/components/shared/BoListFilters.vue";
import ServiceProviderSearch from "@/components/serviceProvider/widget/ServiceProviderSearch.vue";
import SPNav from "@/components/serviceProvider/widget/SPNav.vue";

const serviceProviderModule = namespace("serviceProviderModule");
const serviceProviderServiceModule = namespace("serviceProviderServiceModule");

@Component({
  components: {
    SPNav,
    ServiceProviderSearch,
    BoListFilters,
    ServiceProviderChip,
    CreateButton,
    BoListPanel,
  }
})
export default class ServiceProvidersServices extends Vue {

  @serviceProviderServiceModule.Action('fetchServiceProvidersServices')
  protected fetchServices!: (filters: { spId: number }) => any;
  @serviceProviderServiceModule.Getter('services')
  protected services!: IService[];
  @serviceProviderModule.Action('fetchServiceProvider')
  protected fetchServiceProvider!: (spId: number) => any;
  @serviceProviderModule.Action('fetchServiceProviderLogs')
  protected fetchServiceProviderLogs!: () => any;
  @serviceProviderModule.Getter('serviceProvider')
  protected serviceProvider!: IServiceProvider;
  @Prop()
  protected spId!: number;

  protected defaultLanguage: string = 'en-EN';
  protected language: string = 'en-EN';
  protected search: string = '';
  protected onlyActive: boolean = false;

  protected get activeCnt(): number {
    return this.getServices.filter(each => !!each.active).length;
  }

  protected get createButtonTo() {
    return UrlHelper.mayorServiceProvidersCreateService(this.spId);
  }

  protected get dataTableHeaders(): BetterDataTableHeader[] {
    let ret: BetterDataTableHeader[] = [
      {text: '#', align: 'start', value: 'orderby', sortable: false},
      {text: 'id', align: 'start', value: 'id', sortable: false},
      {text: this.$t('common.name'), align: 'start', value: 'name', sortable: false},
      {text: this.$t('common.price'), align: 'end', value: 'price', sortable: false},
      {text: this.$t('services.services.fields.sale_price.label'), align: 'end', value: 'sale_price', sortable: false},
      {text: this.$t('services.services.fields.minimum_locker_cell_size_id.label'), align: 'center', value: 'minimum_locker_cell_size_id', sortable: false},
      {text: this.$t('services.services.fields.turnaround_time.label'), align: 'center', value: 'turnaround_time', sortable: false},
      {text: this.$t('common.active'), align: 'center', value: 'active', sortable: false},
      {text: '', align: 'start', value: 'controls', sortable: false},
      {text: '', value: 'data-table-expand', sortable: false},
    ];
    return ret.filter((each) =>
        (each.value !== 'active' || this.$vuetify.breakpoint.mdAndUp) &&
        (each.value !== 'minimum_locker_cell_size_id' || this.$vuetify.breakpoint.lgAndUp) &&
        (each.value !== 'turnaround_time' || this.$vuetify.breakpoint.lgAndUp)
    );
  }

  protected get extraFilters(): IAnyObject {
    return {
      spId: this.spId,
      // @todo add search here?
    };
  }

  protected get getServices(): IService[] {
    let ret = this.services;
    if (this.onlyActive) {
      ret = ret.filter(each => each.active);
    }
    if (this.search && (this.search.length > 0)) {
      ret = ret.filter(each => {
        const searchVal = (
            each.id + ' ' +
            JSON.stringify(each.name) + ' ' +
            this.$t('lockers.cells.sizeNames.' + each.minimum_locker_cell_size_id)
        ).toLowerCase();
        return searchVal.includes(this.search.toLowerCase());
      })
    }
    return ret;
  }

  protected get title(): string {
    return this.$t('services.provider.serviceProvidersServices.title') + ' ' +
        (this.serviceProvider ? this.serviceProvider.name : '...');
  }

  created() {
    if (this.$i18n.locale === 'es') {
      this.defaultLanguage = 'es-ES';
      this.language = 'es-ES';
    }
  }

  protected chipColor(item: IService): string {
    return item.active ? 'primary lighten-2' : 'secondary lighten-2';
  }

  protected loadData() {
    this.fetchServiceProvider(this.spId);
    this.fetchServiceProviderLogs();
  }

  protected onActiveClicked(item: IService) {
    this.$comingUp();
  }

  protected onServiceProviderSelected(spId: number) {
    this.search = '';
    this.onlyActive = false;
    if (this.$route.params.spId != `${spId}`) {
      this.$router.push({name: 'serviceProvidersServices', params: {spId: `${spId}`}});
    }
  }

  protected serviceTo(item:IService) {
    return UrlHelper.mayorServiceProvidersService(item.service_provider_id, item.id);
  }

  protected setLanguage(language: string) {
    this.language = language;
  }

  protected sorterFn(items: IService[]) {
    function compare(a: number, b: number) {
      if (a < b) {
        return -1;
      }
      else if (a > b) {
        return 1;
      }
      return 0;
    }
    return items.sort((a: IService, b: IService) => {
      if (a.mandatory && !b.mandatory) {
        return -1;
      }
      else if (!a.mandatory && b.mandatory) {
        return 1;
      }
      else if (a.orderby && !b.orderby) {
        return -1;
      }
      else if (!a.orderby && b.orderby) {
        return 1;
      }
      else if (a.orderby && b.orderby) {
        return compare(a.orderby, b.orderby);
      }
      return compare(a.id, b.id);
    });
  }

  protected translateField(name: ITranslatedField) {
    return TranslationHelper.translateField(name, [this.language, this.defaultLanguage]);
  }

}
